"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isEqual_1 = __importDefault(require("lodash/isEqual"));

var StateProxy =
/*#__PURE__*/
function () {
  function StateProxy() {
    _classCallCheck(this, StateProxy);

    this.localState = null;
    this.forceVegaUpdate = false;
  }

  _createClass(StateProxy, [{
    key: "update",
    value: function update(state) {
      this.localState = state;
    }
  }, {
    key: "getStateDiff",
    value: function getStateDiff(state) {
      return {
        prev: this.localState,
        next: state
      };
    }
  }, {
    key: "userSpecifiedAggregation",
    value: function userSpecifiedAggregation(state) {
      var _this$getStateDiff = this.getStateDiff(state),
          prev = _this$getStateDiff.prev,
          next = _this$getStateDiff.next;

      return !isEqual_1["default"](prev.configuration.aggregateFunction, next.configuration.aggregateFunction || !isEqual_1["default"](prev.configuration.orderBy, next.configuration.orderBy));
    }
  }, {
    key: "handleForceVegaUpdate",
    value: function handleForceVegaUpdate(state) {
      var _this$getStateDiff2 = this.getStateDiff(state),
          prev = _this$getStateDiff2.prev,
          next = _this$getStateDiff2.next;

      if (!isEqual_1["default"](prev.configuration.value, next.configuration.value) || !isEqual_1["default"](prev.configuration.category, next.configuration.category) || !isEqual_1["default"](prev.configuration.color, next.configuration.color) || !isEqual_1["default"](prev.configuration.limit, next.configuration.limit) || !isEqual_1["default"](prev.endUserFilters, next.endUserFilters) || this.userSpecifiedAggregation(state)) {
        this.forceVegaUpdate = true;
      } else {
        this.forceVegaUpdate = false;
      }
    }
  }, {
    key: "ShouldUpdateData",
    value: function ShouldUpdateData(state) {
      var _this$getStateDiff3 = this.getStateDiff(state),
          prev = _this$getStateDiff3.prev,
          next = _this$getStateDiff3.next;

      var shouldUpdate = false;
      shouldUpdate = prev.configuration.limit !== next.configuration.limit;
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.configuration.value, next.configuration.value);
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.configuration.category, next.configuration.category);
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.configuration.color, next.configuration.color);
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.filters.list, next.filters.list);
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.endUserFilters, next.endUserFilters);
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.configuration.aggregateFunction, next.configuration.aggregateFunction);
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.configuration.orderBy, next.configuration.orderBy);
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.configuration.groupBy, next.configuration.groupBy);
      this.handleForceVegaUpdate(state);
      return shouldUpdate;
    }
  }, {
    key: "ShouldUpdateVega",
    value: function ShouldUpdateVega(state) {
      var _this$getStateDiff4 = this.getStateDiff(state),
          prev = _this$getStateDiff4.prev,
          next = _this$getStateDiff4.next;

      if (this.forceVegaUpdate) {
        return true;
      }

      var shouldUpdate = false;
      shouldUpdate = !isEqual_1["default"](prev.theme, next.theme);
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.configuration.chartType, next.configuration.chartType) && next.configuration.chartType !== 'map';
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.editor.widgetData, next.editor.widgetData);
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.configuration.donutRadius, next.configuration.donutRadius);
      shouldUpdate = shouldUpdate || !isEqual_1["default"](prev.configuration.sliceCount, next.configuration.sliceCount);
      shouldUpdate = shouldUpdate || prev.editor.advanced !== next.editor.advanced;
      return shouldUpdate;
    }
  }]);

  return StateProxy;
}();

exports["default"] = StateProxy;